import api from "../services/api"
import { toast } from "react-toastify"

/**
 * Tests the connection to the backend API
 * @returns {Promise<boolean>} True if connection is successful, false otherwise
 */
export const testApiConnection = async () => {
  try {
    // Test the health check endpoint
    const response = await api.get("/health");
    
    if (response.data.status === "ok") {
      toast.success("Connected to backend successfully!");
      return true;
    }
    
    toast.error("Backend responded with unexpected data");
    return false;
  } catch (error) {
    console.error("API Connection Error:", error);
    
    const errorMessage = error.response 
      ? `Backend error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`
      : error.message.includes("Network Error")
        ? "Cannot connect to backend server. Check if it's running and CORS is configured."
        : "Unexpected connection error";

    toast.error(errorMessage);
    
    return false;
  }
};
